module.exports = __webpack_public_path__ + "img/icon-more.7450ad0c.svg";